import React, {FC} from "react"

import {WellnessMedia} from "@irati/types"

interface Props {
  media: WellnessMedia
}

const CourseMedia: FC<Props> = ({media}) => {
  return <div>{media.title}</div>
}

export default CourseMedia
